import React from 'react'
import { Link } from 'react-router-dom'
import {
  CButton,
  CCol,
  CContainer,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilMagnifyingGlass, cilHome, cilArrowLeft } from '@coreui/icons'

const Page404 = () => {
  return (
    <div className="bg-body-tertiary min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <div className="clearfix">
              <h1 className="float-start display-3 me-4">404</h1>
              <h4 className="pt-3">Oops! Page introuvable</h4>
              <p className="text-body-secondary float-start">
                La page que vous recherchez n'existe pas ou a été déplacée.
              </p>
            </div>
            <div className="d-flex gap-2 mt-4">
              <CButton
                color="primary"
                as={Link}
                to="/publications"
                className="d-flex align-items-center gap-2"
              >
                <CIcon icon={cilHome} size="sm" />
                Retour à l'accueil
              </CButton>
              <CButton
                color="secondary"
                onClick={() => window.history.back()}
                className="d-flex align-items-center gap-2"
              >
                <CIcon icon={cilArrowLeft} size="sm" />
                Retour
              </CButton>
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Page404
